import { Validators } from '@angular/forms';
import { regex } from '../../../../common/regex.constants';

export interface EmergencyContactModel {
  firstName: string;
  phoneNumber: string;
  lastName: string;
  id: string;
}

export class EmergencyContact {
  public formBindings: EmergencyContactModel;
  constructor(
    public data?: EmergencyContactModel,
  ) { }

  /**
  * @method __defaults Return the defaults values for the model
  * @returns All the values in the EmailModel interface as ''
  **/
  public __defaults(): EmergencyContactModel {
    return this.formBindings = {
      firstName: '',
      phoneNumber: '',
      lastName: '',
      id: ''
    };
  }
  /**
  * @method values Return the values send in the data property
  * @returns SignUpModel Interface
  **/
  public get values(): EmergencyContactModel {
    return this.data !== undefined ? this.__formBindings({ ...this.data }) : this.__defaults();
  }
  /**
  * @method __formBindings Returns the values for initialize in case of read mode
  * @returns SignUpModel
  **/
  public __formBindings(bindings: EmergencyContactModel): EmergencyContactModel {
    return {
      'firstName': bindings['firstName'] ? bindings['firstName'] : '',
      'phoneNumber': bindings['emails'] ? bindings['emails'] : '',
      'lastName': bindings['lastName'] ? bindings['lastName'] : '',
      'id': bindings['id'] ? bindings['id'] : ''
    };
  }

  /**
  * @method form Return the form controls to be used in the update-account component
  * @returns Object with the controls
  **/
  public get form(): object {
    return this.customerControls;
  }
  /**
  * @method customerControls Controls for the admin view
  * @returns Object with the required controls
  **/
  public get customerControls(): object {
    return {
      firstName: this.firstNameControl,
      lastName: this.lastNameControl,
      phoneNumber: this.phoneNumberControl,
      id: this.idControl,
    };
  }
  /**
  * @method phoneNumberControl Controls for phone field
  * @returns Array of validators
  **/
  public get phoneNumberControl(): any[] {
    return [
      { value: '', disabled: true },
      [Validators.required,
        Validators.minLength(10),
        Validators.maxLength(14),
        Validators.pattern(regex.phoneNumberPattern)]
    ];
  }
  /**
  * @method firstNameControl Controls for first name field
  * @returns Array of validators
  **/
  public get firstNameControl(): any[] {
    return [
      { value: '', disabled: true },
      [Validators.required,
        Validators.maxLength(64),
        Validators.pattern(regex.wordCount),
        Validators.pattern(regex.precedingAndTrailingSpaces)]
    ];
  }
  /**
  * @method lastNameControl Controls for first name field
  * @returns Array of validators
  **/
  public get lastNameControl(): any[] {
    return [
      { value: '', disabled: true },
      [Validators.required,
        Validators.maxLength(64),
        Validators.pattern(regex.wordCount),
        Validators.pattern(regex.precedingAndTrailingSpaces)]
    ];
  }
    /**
  * @method idControl Controls for id
  * @returns Array of validators
  **/
     public get idControl(): any[] {
      return [
        { value: '', disabled: true },
      ];
    }
  /**
  * @function actionName returns the translation for button name when called
  * @returns Array<string>
  **/
  get actionName(): Array<string> {
    return ['emergency-contact.action.update', 'emergency-contact.action.edit'];
  }
}

